<template>
  <el-dialog
    :model-value="visible"
    :close-on-click-modal="false"
    :title="$t('main_header_change_SYS_password')"
    width="400px"
    @close="handleCancel"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      size="small"
    >
      <el-form-item
        prop="oldPassword"
        :label="$t('main_header_old_password')"
      >
        <el-input
          v-model="form.oldPassword"
          :type="visibility.oldPassword ? 'text' : 'password'"
          :placeholder="$t('main_login_placeholder_input')"
          maxlength="20"
          autocomplete="off"
        >
          <template #suffix>
            <i
              :class="['toggle-view', 'iconfont', visibility.oldPassword ? 'el-icon-view' : 'el-icon-unview']"
              role="button"
              tabindex="0"
              @click="toggleVisibility('oldPassword')"
              @keydown.enter.prevent="toggleVisibility('oldPassword')"
              @keydown.space.prevent="toggleVisibility('oldPassword')"
            ></i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        prop="newPassword"
        :label="$t('main_header_new_password')"
      >
        <el-input
          v-model="form.newPassword"
          :type="visibility.newPassword ? 'text' : 'password'"
          :placeholder="$t('main_login_placeholder_input')"
          maxlength="20"
          autocomplete="off"
        >
          <template #suffix>
            <i
              :class="['toggle-view', 'iconfont', visibility.newPassword ? 'el-icon-view' : 'el-icon-unview']"
              role="button"
              tabindex="0"
              @click="toggleVisibility('newPassword')"
              @keydown.enter.prevent="toggleVisibility('newPassword')"
              @keydown.space.prevent="toggleVisibility('newPassword')"
            ></i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        prop="confirmPassword"
        :label="$t('main_header_confirm_password')"
      >
        <el-input
          v-model="form.confirmPassword"
          :type="visibility.confirmPassword ? 'text' : 'password'"
          :placeholder="$t('main_login_placeholder_input')"
          maxlength="20"
          autocomplete="off"
        >
          <template #suffix>
            <i
              :class="['toggle-view', 'iconfont', visibility.confirmPassword ? 'el-icon-view' : 'el-icon-unview']"
              role="button"
              tabindex="0"
              @click="toggleVisibility('confirmPassword')"
              @keydown.enter.prevent="toggleVisibility('confirmPassword')"
              @keydown.space.prevent="toggleVisibility('confirmPassword')"
            ></i>
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="handleCancel">{{ $t('main_header_cancel') }}</el-button>
      <el-button :loading="isLoading" type="primary" @click="handleSubmit">{{ $t('main_header_confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { updateUserPassword } from '@/services/micro-app-cache'

export default {
  name: 'ChangePwd',
  props: {
    visible: Boolean
  },
  emits: ['update:visible'],
  data () {
    const newValidate = (rule, value, callback) => {
      const pwd = String(value || '')
      const isLen = pwd.length >= 8 && pwd.length <= 12
      const hasUpper = /[A-Z]/.test(pwd)
      const hasLower = /[a-z]/.test(pwd)
      const hasDigit = /[0-9]/.test(pwd)
      const hasSpecial = /[^A-Za-z0-9]/.test(pwd)
      const typeCount = [hasUpper, hasLower, hasDigit, hasSpecial].filter(Boolean).length

      if (!isLen || typeCount < 3) {
        callback(new Error(this.$t('web.dsp.newPasswordValidTip')))
        return
      }

      callback()
    }

    const confirmValidate = (rule, value, callback) => {
      const confirmPwd = String(value || '')
      if (!confirmPwd) return callback()
      if (confirmPwd !== this.form.newPassword) {
        callback(new Error(this.$t('web.dsp.confirmPasswordValidTip')))
        return
      }
      callback()
    }

    return {
      form: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      },
      visibility: {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
      },
      rules: {
        oldPassword: [
          { required: true, message: this.$t('common_canNotBeEmpty'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t('common_canNotBeEmpty'), trigger: 'blur' },
          { validator: newValidate, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: this.$t('common_canNotBeEmpty'), trigger: 'blur' },
          { validator: confirmValidate, trigger: 'blur' }
        ]
      },
      isLoading: false
    }
  },
  methods: {
    toggleVisibility (key) {
      this.visibility[key] = !this.visibility[key]
    },
    handleCancel () {
      this.form = {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
      this.visibility = {
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
      }
      this.isLoading = false
      this.$refs.form.clearValidate()
      this.$emit('update:visible', false)
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
        this.isLoading = true
        const { oldPassword, newPassword } = this.form
        await updateUserPassword({ oldPassword, newPassword })
        this.$emit('update:visible', false)
        this.$message.success(this.$t('main_header_change_success'))
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-view {
  padding-left: 10px;
  cursor: pointer;
  font-size: 24px;
  line-height: 32px;
  user-select: none;
}

:deep(.el-form-item) {
  .el-form-item__label {
    padding-bottom: 0;
  }

  .el-form-item__error {
    position: static;
    white-space: normal;
    line-height: 16px;
    margin-top: 4px;
    word-break: break-word;
  }
}
</style>
